import { createSlice } from "@reduxjs/toolkit"
import { seasonFormObject } from "@form/seasonFormFields"

const missionSeasonSlice = createSlice({
  name: 'missionSeason',
  initialState: {
    missionSeasons: null,
    seasonFormObject: { ...seasonFormObject },
    errors: {}
  },
  reducers: {
    updateSeasonFormObject: (state, action) => {
      state.seasonFormObject = action.payload
    },
    initSeasonFormObject: (state) => {
      state.seasonFormObject = { ...seasonFormObject }
    },
    updateMissionSeasons: (state, action) => {
      state.missionSeasons = action.payload
    },
    addMissionSeason: (state, action) => {
      state.missionSeasons = [...state.seasons, action.payload]
    },
    updateErrors: (state, action) => {
      state.errors = action.payload
    }
  }
})

export const {
  updateSeasonFormObject,
  initSeasonFormObject,
  updateMissionSeasons,
  addMissionSeason,
  updateErrors
} = missionSeasonSlice.actions

export default missionSeasonSlice.reducer